//#region Styles
import { Row } from "components/styles";
import{
    Container,
    Content
} from "./styles";
//#endregion
//#region Components 
import HelmetUTP from "components/HelmetUTP/HelmetUTP";
import CardLinkItem from '../../components/CardLinkItem/primary/CardLinkItem';
//#endregion
//#region Images
import mainImg from "./img/main_img.png";
import { HOME_CARD_LINK_PROPS_LIST } from "./utils/constants";
//#endregion

const Home = ({
    moduleIdsViewsOfCurrentUser
}) => {
    return (
        <Container>
            <HelmetUTP title="Home"/>
            <Content>
                <img src={mainImg} alt="imagen principal"/>
                <p>¿Qué deseas registrar hoy?</p>
                <Row justifyContent="center">
                    {HOME_CARD_LINK_PROPS_LIST
                        .filter(({ id }) => (
                            // Verificando permisos según el usuario
                            moduleIdsViewsOfCurrentUser.includes(id)
                        ))
                        .map(info => (
                            <CardLinkItem
                                key={info.id}
                                {...info}/>
                        ))}
                </Row>
            </Content>
        </Container>
    );
}

export default Home;